import { render, staticRenderFns } from "./NcInterneActions.vue?vue&type=template&id=bb52d88c&scoped=true"
import script from "./NcInterneActions.vue?vue&type=script&lang=js"
export * from "./NcInterneActions.vue?vue&type=script&lang=js"
import style0 from "./NcInterneActions.vue?vue&type=style&index=0&id=bb52d88c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb52d88c",
  null
  
)

export default component.exports